// extracted by mini-css-extract-plugin
export default {"summaryList":"summary-summaryList-NLhEJl","summaryListRow":"summary-summaryListRow-L7_5Qk","key":"summary-key-Pml8uw","value":"summary-value-tbpnm9"};